import useDictStore from '@/store/modules/dict'
import { getDicts } from '@/api/system/dict/data'

/**
 * 获取字典数据
 */
export function useDict (...args) {
  const res = ref({});
  return (() => {
    args.forEach((dictType, index) => {
      res.value[dictType] = [];
      const dicts = useDictStore().getDict(dictType);
      if (dicts) {
        res.value[dictType] = dicts;
      } else {
        getDicts(dictType).then(resp => {
          res.value[dictType] = resp.data.map(p => ({ label: p.dictLabel, value: p.dictValue, elTagType: p.listClass, elTagClass: p.cssClass,remark:p.remark }))
          useDictStore().setDict(dictType, res.value[dictType]);
        })
      }
    })
    return toRefs(res.value);
  })()
}



//订单类型数据
export const orderTypeArr = [
  { label: '全部', value: '' },
  { label: '课程订单', value: '课程订单' },
  { label: '教材订单', value: '教材订单' },
  { label: '学历订单', value: '学历订单' },
  { label: '网校订单', value: '网校订单' },
  { label: '考试费订单', value: '考试费订单' },
  { label: '一对一订单', value: '一对一订单' },
  { label: '财税咨询订单', value: '财税咨询订单' },
  { label: '上海项目订单', value: '上海项目订单' },
];
